module.exports = __webpack_public_path__ + "static/img/dyInfo03.d226b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/dyInfo03.jpg
// module id = rqeS
// module chunks = 0